/* eslint-disable*/
import VueStoreService from './VueStoreService';
const NationalService = {
  //Nacional
  async getNationals(url, store) {
    var resp = await VueStoreService.get("national-purchase" + url, store)
    return resp;
  },
  async getNationalById(national_id, store) {
    var resp = await VueStoreService.get("national-purchase/" + national_id, store)
    return resp;
  },  
  async saveNational(data, store) {
    var resp = await VueStoreService.post("national-purchase", data, store)
    return resp;
  },
  async updateNational(national_id, data, store) {
    var resp = await VueStoreService.patch("national-purchase/" + national_id, data, store)
    return resp;
  },
  async deleteNational(national_id, store) {
    var resp = await VueStoreService.delete("national-purchase/" + national_id, store)
    return resp;
  },
  //Detalle Nacional
  async getDetails(url, store) {
    var resp = await VueStoreService.get("detail-national"+ url, store)
    return resp;
  },
  async saveDetailNational(data, store) {
    var resp = await VueStoreService.post("detail-national", data, store)
    return resp;
  },
  async deleteDetailNational(national_id, store) {
    var resp = await VueStoreService.delete("detail-national/" + national_id, store)
    return resp;
  },
}

export default NationalService;